import { getApiErrorMessage } from '../../../services/axios.service'

export const RELEASE_SEATS_ERROR_MESSAGE =
	'Não foi possível liberar a poltrona escolhida antes. Aguarde um instante e tente novamente.'

/**
 * Spec 056 (E21, auditoria da entrega): ao trocar de viagem, as poltronas já reservadas são liberadas antes de abrir o
 * novo mapa. Com a reserva anterior ainda em andamento (ou mantida), o MuviHub responde 409/502 e o DELETE rejeita — sem
 * este tratamento o carregamento ficava na tela para sempre e nenhuma mensagem aparecia (a página de compra silencia o
 * aviso automático: toastIgnorePaths). Aqui: tira o carregamento, mostra a mensagem do Hub (ou uma genérica) e diz ao
 * chamador para não seguir com a troca.
 *
 * @param {() => Promise<any>} deselect libera as poltronas atuais
 * @param {() => void} hideLoading tira o carregamento
 * @param {(payload: { message: string }) => void} notify mostra o aviso
 * @return {Promise<boolean>} true se liberou (segue a troca); false se falhou (já avisado)
 */
export async function releaseSeatsBeforeTripChange(deselect, hideLoading, notify) {
	try {
		await deselect()
		return true
	} catch (error) {
		hideLoading()
		notify({ message: getApiErrorMessage(error) || RELEASE_SEATS_ERROR_MESSAGE })
		return false
	}
}
